// ------------------------------------
// Constants/Types
// ------------------------------------

const UPDATE_MAIN_TIME_PERIOD = 'src/main-time-comparison-time-period/UPDATE_MAIN_TIME_PERIOD';

export default {
  UPDATE_MAIN_TIME_PERIOD
};
